module.exports = __webpack_public_path__ + "img/arrow-right.0aa8353.svg";